@if (tabs.length) {
  <ul role="tablist">
    @for (tab of tabs; track tab) {
      <li>
        <a
          href="#"
          [class.active]="tab.active"
          (click)="selectTab($event, tab)"
          role="presentation"
        >
          {{ tab.label }}
        </a>
      </li>
    }
  </ul>
}

<ng-content></ng-content>
